module.exports = __webpack_public_path__ + "static/media/Template_34.f933d5be.png";